import React from 'react';
import { makeStyles, Box, Theme } from '@material-ui/core';
import { EntrepreneurProfileBody } from '../../types/types';
import EditPencil from '../../components/EditPencil';
import { StyledText } from '../../components/StyledText';
import FinanceTable from '../../components/FinanceTable';
import DetectLinks from '../../components/DetectLinks';
import { tbd } from '../../lib/utils';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 928,
    padding: 20,
    [theme.breakpoints.up('md')]: {
      padding: 35
    },
    position: 'relative',
    '& h5': {
      margin: '30px 0 10px 0'
    }
  }
}));

interface EntExecSummaryPanelProps {
  profile: EntrepreneurProfileBody
  editable: boolean
  openEdit: () => void
}

const EntExecSummaryPanel: React.FC<EntExecSummaryPanelProps> = ({
  profile,
  editable,
  openEdit
}) => {
  const {
    background,
    distribution,
    management,
    financialProjection,
    market,
    competition
  } = profile;

  const styles = useStyles();
  return (
    <Box className={styles.root}>
      {editable && <EditPencil onClick={openEdit} style={{ top: 10, right: 10, position: 'absolute' }} />}
      <StyledText variant='h2' color='textPrimary' style={{ marginTop: '15px' }}>
        Company Background:
      </StyledText>
      <StyledText variant='body1' style={{ marginBottom: '25px' }} color={background ? 'textPrimary' : 'textSecondary'}>
        <DetectLinks content={background || tbd} />
      </StyledText>
      <StyledText variant='h2' color='textPrimary' style={{ marginTop: '15px' }}>
        Management:
      </StyledText>
      <StyledText variant='body1' style={{ marginBottom: '25px' }} color={background ? 'textPrimary' : 'textSecondary'}>
        <DetectLinks content={management || tbd} />
      </StyledText>
      <StyledText variant='h2' color='textPrimary' style={{ marginTop: '15px' }}>
        Market:
      </StyledText>
      <StyledText variant='body1' style={{ marginBottom: '25px' }} color={background ? 'textPrimary' : 'textSecondary'}>
        <DetectLinks content={market || tbd} />
      </StyledText>
      <StyledText variant='h2' color='textPrimary' style={{ marginTop: '15px' }}>
        Distribution Channels:
      </StyledText>
      <StyledText variant='body1' style={{ marginBottom: '25px' }} color={background ? 'textPrimary' : 'textSecondary'}>
        <DetectLinks content={distribution || tbd} />
      </StyledText>
      <StyledText variant='h2' color='textPrimary' style={{ marginTop: '15px' }}>
        Competition:
      </StyledText>
      <StyledText variant='body1' style={{ marginBottom: '25px' }} color={background ? 'textPrimary' : 'textSecondary'}>
        <DetectLinks content={competition || tbd} />
      </StyledText>
      <StyledText variant='h2'>Financial Projections</StyledText>
      <StyledText color='textSecondary' style={{ marginBottom: 20 }}>unaudited, dollars in millions</StyledText>
      <FinanceTable editable={false} vertical={false} projections={financialProjection} />
    </Box>
  );
};

export default EntExecSummaryPanel;
